import { getLocale } from "../runtime";

const sv_hide = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Dölj`
};

const hide = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_hide(inputs)
	return "hide";
};

export { hide as "hide" };